import { formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ComprasService } from 'src/app/services/compras.service';
import { ReportsService } from 'src/app/services/reports.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-tickets-profile',
  templateUrl: './tickets-profile.component.html',
  styleUrls: ['./tickets-profile.component.scss']
})
export class TicketsProfileComponent implements OnInit {

  purchases: any[] = [];
  purchasesByMonth: { month: string, dateKey: Date, items: any[], open: boolean }[] = [];
  index: number = 0;

  page: number = 1;
  items: number = 12;
  loadingPage = false;

  finishScroll: boolean = false;
  open: boolean = false;
  tickets: any[] = [];

  // En tu componente .ts
  repeatArray = Array(10); // crea un array de 10 elementos (undefined)


  @ViewChild('containerEvents', { static: false }) containerEvents: ElementRef;
  loadingLottie: AnimationOptions = {
    path: 'assets/lotties/loading.json',
  };

  constructor(private auth: AuthenticationService, private dialog: MatDialog, private router: Router,
    private comprasService: ComprasService, private reportService: ReportsService) { }

  ngOnInit(): void {
    this.initLoading();
  }

  initLoading() {
    this.goToTop();
    this.purchases = [];
    this.loadingPage = true;
    this.page = 1;
    this.finishScroll = false;
    setTimeout(() => {
      this.getData();
    }, 200);
  }

  backTab() {
    this.router.navigate(['/profile']);
  }

  getData() {
    this.comprasService.getCompras(this.page, this.items).subscribe(data => {
      let countTickets = 0;
      if (data) {
        data.forEach(element => {
          countTickets += element.entradas.length;
          element.refund = !element.entradas?.find((value) => !value.status || value.status.id != 2)
        });
        this.purchases = this.purchases.concat(data);
      }
      this.finishScroll = countTickets < this.items;
      this.loadingPage = false;
      this.groupPurchasesByMonth();

    })
  }

  groupPurchasesByMonth() {
    const grouped: { [key: string]: { dateKey: Date, items: any[] } } = {};

    this.purchases.forEach(purchase => {
      const date = new Date(purchase.createdAt);
      const key = formatDate(date, 'MMMM yyyy', 'es');
      const monthStart = new Date(date.getFullYear(), date.getMonth(), 1); // Para ordenar

      if (!grouped[key]) {
        grouped[key] = {
          dateKey: monthStart,
          items: []
        };
      }

      grouped[key].items.push(purchase);
    });

    this.purchasesByMonth = Object.entries(grouped)
      .map(([month, { dateKey, items }]) => ({
        month,
        dateKey,
        items,
        open: false // por defecto cerrados
      }))
      .sort((a, b) => b.dateKey.getTime() - a.dateKey.getTime()); // más reciente primero

    // Abrimos el primer grupo (más reciente)
    if (this.purchasesByMonth.length > 0) {
      this.purchasesByMonth[0].open = true;
    }
  }

  toggleGroup(group: any) {
    group.open = !group.open;
  }




  @HostListener('window:scroll', ['$event'])
  @HostListener('scroll')
  public isScrolled(event) {
    if (!this.finishScroll && !this.loadingPage) {
      const element = this.containerEvents.nativeElement.getBoundingClientRect();
      let bottomShown = element.bottom <= window.innerHeight;

      if (bottomShown) {
        this.page++;
        this.loadingPage = true;
        setTimeout(() => {
          this.getData();
        }, 500);
      }
    }
  }

  editAction(event: any) {
    if (event) {
      const dialogRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: false,
          text: 'Acción realizada correctamente',
          btnCancel: false,
        }
      });
    }
  }

  goToTop() {
    window.scrollTo(0, 0);
  }

  printPurchase(idTicket: number) {
    this.reportService.getUrlsDownload(idTicket).subscribe({
      next: (url) => {
        let uriDownload = url['ticket_a4'];
        setTimeout(() => {
          const newWindow = window.open(uriDownload, '_blank');
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            window.location.href = uriDownload;
          }
          this.openInfoCard('Se ha descargado el ticket correctamente.', false, false);

        }, 100);
      }, error: (err) => {
        this.openInfoCard('Lo sentimos, no se han podido descargar las entradas.', true, false);
      }
    })
  }

  openInfoCard(msg: string, disabledClose: boolean = false, icon: boolean = true) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        icon: icon,
        text: msg,
        btnCancel: false
      }
    });
  }

}
